<template>
  <div>
    <img
      class="img-fluid"
      src="@/assets/img/ilustrations/ilustration02.jpg"
      alt=""
    />
    <FormWizardStepHeader
      class="mt-30"
      title="Ready to submit?"
      description="You’re all ready to go. Submit your profile, but don’t worry you can edit anytime."
    />
  </div>
</template>

<script>
import FormWizardStepHeader from '@/components/FormWizardStepHeader'
export default {
  components: { FormWizardStepHeader },
  props: {
    v: Object
  }
}
</script>
